<template>
  <section ref="root" class="about-us-map mb6 flex justify-center">
    <BravadoMap v-if="showMap" />
  </section>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from '@nuxtjs/composition-api';

const BravadoMap = () => import('@/components/partials/landings/ui/BravadoMap.vue');

const showMap = ref(false);
const root = ref<HTMLElement | null>(null);
let observer: IntersectionObserver | undefined;

onMounted(() => {
  if (root.value) {
    observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        showMap.value = true;
        observer?.disconnect();
      }
    });

    console.log('observing');
    observer.observe(root.value);
  }
});

onUnmounted(() => {
  console.log('unobserving');
  observer?.disconnect();
});
</script>

<style lang="scss" scoped>
.about-us-map {
  overflow-x: auto;
  height: 562px;

  @include mq('md') {
    margin-bottom: 55px;
  }
}
</style>
